const categoriesList = (state) => state.categories;

export default {
    categoriesList,
};

